const ar = {
    login: "تسجيل الدخول",
    logout: "تسجيل الخروج",
    signIn: "دخول",
    signOut: "خروج",
    profile: "الملف الشخصي",
    settings: "الإعدادات",
    digiAirMenuWaiterLogin: "دخول النادل إلى DigiAirMenu",
    appLogoAlt: "شعار digiAirMenu",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    pinCode: "رمز PIN",
    yourAuthenticationFailed: "فشل تسجيل الدخول",
    addDAMToHomeScreen: "أضف DigiAirMenu إلى الشاشة الرئيسية",
    addToHomeScreen: "إضافة إلى الشاشة الرئيسية",
    installDAM: "تثبيت DAM",
    language: "اللغة",
    chooseLanguage: "اختر اللغة",
    pageNotFound: "الصفحة غير موجودة",
    backToDashboard: "العودة إلى لوحة التحكم",
    transferToDemo: "الانتقال إلى الوضع التجريبي",
    transferToLive: "الانتقال إلى الوضع المباشر",
    currentTable: "طاولة الحالي",
    table: "طاولة",
    tables: "الطاولات",
    order: "طلب",
    orders: "الطلبات",
    option: "خيار",
    additive: "إضافة",
    options: "الخيارات",
    additives: "الإضافات",
    empty: "فارغ",
    row: "صف",
    count: "العدد",
    step: "الخطوة",
    title: "العنوان",
    untitledItem: "بدون عنوان",
    createdAt: "أُنشئ في",
    free: "مجاني",
    freeItems: "عناصر مجانية",
    items: "عناصر",
    item: "عنصر",
    itemsCountOfAll: "{{payCount}} من {{maxCount}}",
    minimum: "الحد الأدنى",
    maximum: "الحد الأقصى",
    min: "أدنى",
    max: "أقصى",
    all: "الكل",
    unitPrice: "سعر الوحدة",
    email: "البريد الإلكتروني",
    print: "طباعة",
    printingFailed: "فشلت الطباعة!",
    checkoutPrintDataUnavailable: "بيانات إيصال الدفع غير متاحة للطباعة",
    printUsingExternalDevice: "الطباعة باستخدام جهاز خارجي",
    orderDetails: "تفاصيل الطلب",
    noOrders: "لا توجد طلبات",
    noOrdersAdded: "لم تتم إضافة أي طلبات",
    noAddedItems: "لم تتم إضافة أي عناصر",
    loading: "جارٍ التحميل",
    createOrSelectOrderAfterSelectingTable: "اختر طاولة أولاً ثم أنشئ/اختر طلبًا",
    createOrSelectOrderFirst: "أنشئ/اختر طلبًا أولاً",
    customFood: "عنصر مخصص",
    customFoods: "عناصر مخصصة",
    normalFoodOrDrink: "طعام/شراب عادي",
    customMenuItems: "عناصر قائمة مخصصة",
    sentToKitchen: "تم الإرسال إلى المطبخ",
    sendToKitchen: "إرسال إلى المطبخ",
    orderDelivered: "تم تسليم الطلب",
    orderDeliveredConfirmation: "هل أنت متأكد من أن هذا الطلب تم تسليمه؟",
    selectItemsForSendingToKitchen: "اختر العناصر لإرسالها إلى المطبخ",
    type: "النوع",
    status: "الحالة",
    ItemDetailsAndStatus: "تفاصيل / حالة العنصر",
    description: "الوصف",
    typeAnythingYouNeed: "اكتب أي شيء تحتاجه",
    paid: "مدفوع",
    partiallyPaid: "مدفوع جزئياً",
    unpaid: "غير مدفوع",
    pending: "قيد الانتظار",
    canceled: "ملغي",
    created: "تم الإنشاء",
    accepted: "تم القبول",
    arrival: "الوصول",
    late_arrival: "وصول متأخر",
    late_pickup: "استلام متأخر",
    request_new_driver: "طلب سائق جديد",
    shipment_destroyed: "تم إتلاف الشحنة",
    address_not_found: "العنوان غير موجود",
    completed: "مكتمل",
    late_completed: "اكتمل متأخرًا",
    isPaid: "مدفوع",
    total: "الإجمالي",
    editOrderItem: "تعديل عنصر الطلب",
    chooseTable: "اختر الطاولة",
    pickup: "استلام",
    suspended: "معلّق",
    processing: "قيد المعالجة",
    rejected: "مرفوض",
    delivered: "تم التسليم",
    ordersList: "قائمة الطلبات",
    showOlderOrders: "عرض الطلبات الأقدم",
    showHistory: "عرض السجل",
    showCanceledOrders: "عرض الطلبات الملغاة",
    showDeliveredOrders: "عرض الطلبات المسلّمة",
    showPaidOrders: "عرض الطلبات المدفوعة",
    listOfOrders: "قائمة الطلبات",
    listOfolderOrRejectedOrdersTitle: "أقدم / مرفوض",
    addNewOrder: "إضافة طلب جديد",
    ordering: "تسجيل الطلب",
    availableFoods: "العناصر المتاحة",
    searchByTableName: "البحث باسم الطاولة",
    Layout: "التخطيط",
    gridView: "عرض شبكي",
    listView: "عرض قائمة",
    Filters: "الفلاتر",
    availableItems: "العناصر المتاحة",
    searchByFoodName: "البحث باسم الطعام",
    allCategories: "كل الفئات",
    noCategories: "لا توجد فئات",
    addFood: "إضافة عنصر",
    editManualItem: "تعديل عنصر يدوي",
    addManualItem: "إضافة عنصر يدوي",
    manualItem: "عنصر يدوي",
    manualItems: "عناصر يدوية",
    areYouSureYouWantToConvertOrderToDemoModeOrder: "هل أنت متأكد أنك تريد تحويل الطلب <1>{{orderId}}</1> إلى طلب تجريبي؟",
    areYouSureYouWantToConvertOrderToLiveModeOrder: "هل أنت متأكد أنك تريد تحويل الطلب <1>{{orderId}}</1> إلى طلب مباشر؟",
    areYouSureYouWantToSwitchToLiveMode: "هل أنت متأكد أنك تريد التبديل إلى الوضع المباشر؟",
    areYouSureYouWantToSwitchToDemoMode: "هل أنت متأكد أنك تريد التبديل إلى الوضع التجريبي؟",
    areYouWantDeleteThisItem: "هل أنت متأكد أنك تريد حذف هذا العنصر؟",
    areYouWantCancelOrder: "هل أنت متأكد أنك تريد إلغاء هذا الطلب؟",
    getEmailLabel: "يرجى إدخال البريد الإلكتروني",
    enterValidEmailErr: "يرجى إدخال بريد إلكتروني صالح.",
    sendEmail: "إرسال البريد الإلكتروني",
    send: "إرسال",
    sendReceiptInfo: "إرسال تفاصيل الإيصال",
    resendPaymentLink: "إعادة إرسال رابط الدفع",
    sendMenuSms: "إرسال رابط القائمة",
    sendMenuLinkBySms: "إرسال رابط القائمة عبر الرسائل",
    menuLinkSentSuccessfully: "تم إرسال رابط القائمة بنجاح",
    paymentLinkResentSuccessfully: "تم إرسال رابط الدفع بنجاح",
    receiverEmail: "بريد المستلم",
    receiverPhone: "هاتف المستلم",
    receiverEmailPlaceholder: "example@email.com",
    emailIsRequired: "البريد الإلكتروني مطلوب",
    phoneNumberIsRequired: "رقم الهاتف مطلوب",
    emailOrPhoneIsRequired: "البريد الإلكتروني أو رقم الهاتف مطلوب",
    invalidEmailFormat: "صيغة البريد الإلكتروني غير صحيحة",
    iUnderstand: "أفهم",
    no: "لا",
    yes: "نعم",
    cancel: "إلغاء",
    close: "إغلاق",
    back: "رجوع",
    next: "التالي",
    previous: "السابق",
    add: "يضيف",
    preview: "معاينة",
    changeTable: "تغيير الطاولة",
    saveChanges: "حفظ التغييرات",
    confirm: "تأكيد",
    unselectAll: "إلغاء تحديد الكل",
    selectAll: "تحديد الكل",
    selected: "محدد",
    reset: "إعادة تعيين",
    clear: "مسح",
    mobileKeyboard: "لوحة مفاتيح الهاتف",
    externalDeliveryOrder: "طلب توصيل خارجي",
    externalDeliveryOrderDescription: "يجب قبول هذا الطلب قبل معالجته",
    waiterDraftOrder: "طلب أنشأه النادل",
    waiterDraftOrderDescription: "ما زال بإمكانك تعديل هذا الطلب. أكّده عندما يصبح كل شيء جاهزًا.",
    accept: "قبول",
    acceptOrder: "قبول الطلب",
    confirmOrder: "تأكيد الطلب",
    completeOrderSetup: "إكمال إعداد الطلب",
    completeOrderSetupDialogTitle: "أكمل تفاصيل التوصيل وثبّت توقيت الطلب",
    acceptOrderDialogTitle: "سيؤدي قبول هذا الطلب إلى بدء التحضير وإبلاغ المطبخ",
    confirmOrderDialogTitle: "سيؤدي تأكيد هذا الطلب إلى قفل التعديلات وبدء التحضير",
    acceptOrderExternalDescription: "تم تقديم هذا الطلب من مصدر خارجي. اقبله لبدء التحضير، أو ارفضه إذا لم تتمكن من تنفيذه.",
    confirmOrderWaiterCreatedDescription: "أنشأ النادل هذا الطلب. راجعه وأكّده عندما تصبح كل العناصر جاهزة.",
    acceptOrderWaiterCreatedDescription: "أنشأ النادل هذا الطلب. اقبله لقفل التعديلات وبدء التحضير.",
    editingLockedForCustomerOrder: "التعديل مقفل لطلبات الزبائن.",
    editingLockedForRejectedOrder: "التعديل مقفل لأن هذا الطلب تم رفضه.",
    editingLockedCustomerOrderAfterAcceptance: "يتم قفل التعديل لطلبات الزبائن بعد القبول.",
    editingLockedAfterConfirmation: "يتم قفل التعديل بعد تأكيد الطلب.",
    editingDoneOrderItemLocked: "لا يمكن تعديل العناصر التي تم إنجازها بالفعل.",
    editingPaidOrderItemLocked: "لا يمكن تعديل العناصر المدفوعة.",
    editingPendingPaymentOrderItemLocked: "لا يمكن تعديل هذا العنصر أثناء معالجة الدفع.",
    editingSentToKitchenItemLockedByPermission: "ليست لديك صلاحية لتعديل العناصر التي أُرسلت بالفعل إلى المطبخ.",
    rejectOrder: "رفض الطلب",
    rejectOrderConfirm: "هل أنت متأكد أنك تريد رفض هذا الطلب؟",
    acceptOrderPickupTimeHelperText: "يمكنك تأخير وقت الاستلام حتى <1>30 دقيقة</1>",
    pleaseEnterPickupTime: "يرجى إدخال وقت الاستلام",
    addToOrders: "إضافة إلى الطلبات",
    cancelThisOrder: "إلغاء هذا الطلب",
    cancelOrder: "إلغاء الطلب",
    orderModeChangedToDemoInJSX: "تم تغيير وضع الطلب المطلوب إلى الوضع التجريبي بعنوان '<1>الطلب {{targetOrderId}}</1>'.",
    orderModeChangedToLiveInJSX: "تم تغيير وضع الطلب المطلوب إلى الوضع المباشر بعنوان '<1>الطلب {{targetOrderId}}</1>'.",
    checkoutHasPaidByPosInJSX: "تم دفع <1>عملية الدفع</1> ذات المعرّف <3>{{checkout_id}}</3> من <5>الطلب {{order_id}}</5> بنجاح عبر POS.",
    demo: "تجريبي",
    demoModeIsActive: "وضع العرض التوضيحي مُفعّل",
    demoModeAlertMessage: "يُستخدم وضع العرض التوضيحي لأغراض التدريب والاختبار فقط. يتحمل صاحب المطعم وحده مسؤولية استخدام النظام والامتثال لجميع اللوائح القانونية المعمول بها أثناء تفعيل وضع العرض التوضيحي.",
    normal: "عادي",
    showOrderInTargetMode: "عرض الطلب في وضع {{targetMode}}",
    showOrder: "عرض الطلب",
    openOrderInBackground: "<0>فتح</0> <1>(في الخلفية)</1>",
    incomingOrderNotificationTitle: "تم استلام طلب جديد",
    incomingOrderNotificationDescription: "وصل طلب من عميل. استخدم الزر أدناه لفتحه في الخلفية بدون إغلاق هذه النافذة.",
    yesDeleteIt: "نعم، احذفه",
    pay: "دفع",
    payment: "دفع",
    payments: "المدفوعات",
    payReport: "تقرير الدفع",
    paymentOf: "دفعة",
    checkoutOperation: "عملية الدفع",
    itemsToPay: "العناصر المطلوب دفعها",
    price: "السعر",
    basicPrice: "السعر الأساسي",
    totalPrice: "السعر الإجمالي",
    baseAmount: "المبلغ الأساسي",
    paidPrice: "المبلغ المدفوع",
    paidBy: "دفع بواسطة",
    discount: "الخصم",
    discountAmount: "قيمة الخصم",
    tipPrice: "قيمة البقشيش",
    totalWithTip: "الإجمالي مع البقشيش",
    amountToPay: "المبلغ المطلوب دفعه",
    paymentAmount: "مبلغ الدفع",
    paymentsIncludingDiscounts: "المدفوعات شاملاً الخصومات",
    paymentsExcludingDiscounts: "المدفوعات بدون الخصومات",
    paymentsTakingIntoAccountTheirDiscount: "المدفوعات مع احتساب الخصم",
    paymentsRegardlessOfTheirDiscount: "المدفوعات بغض النظر عن الخصم",
    openPaymentsStatistics: "إحصاءات المدفوعات المفتوحة",
    discountCannotBeLessThanZero: 'لا يمكن أن تكون قيمة الخصم أقل من "0"',
    discountCannotBeNegative: "لا يمكن أن تكون قيمة الخصم سالبة",
    discountCannotBeMoreThanHundredPercent: 'لا يمكن أن تتجاوز قيمة الخصم "100%"',
    discountCannotBeMoreThan: "لا يمكن أن تتجاوز قيمة الخصم {{price}}",
    theValueMustBeMoreThan: "يجب أن تكون القيمة أكبر من {{price}}",
    theValueMustBeMoreThanBaseAmount: "يجب أن تكون القيمة أكبر من المبلغ الأساسي",
    valueMustBeLessThanOrEqualToMessage: "يجب أن تكون القيمة أقل من أو تساوي {{maxPrice}}",
    valueMustBeGreaterThanZeroMessage: "يجب أن تكون القيمة أكبر من 0",
    tip: "بقشيش",
    tipAmount: "قيمة البقشيش",
    tipCannotBeNegative: "لا يمكن أن تكون قيمة البقشيش سالبة",
    payByCreditCard: "الدفع ببطاقة ائتمان",
    payInCash: "الدفع نقدًا",
    cardTransfer: "تحويل بطاقة",
    checkout: "دفع",
    transaction: "معاملة",
    noTransactionHasBeenMade: "لم تتم أي معاملة",
    backToTransactionsList: "العودة إلى قائمة المعاملات",
    transactionsHistory: "سجل المعاملات",
    transactionDetails: "تفاصيل المعاملة",
    transactionId: "معرّف المعاملة",
    transactionHasBeenSentToYourEmail: "تم إرسال المعاملة إلى بريدك الإلكتروني",
    paymentType: "نوع الدفع",
    paymentStatus: "حالة الدفع",
    ordersPrice: "قيمة الطلبات",
    totalAmount: "المبلغ الإجمالي",
    updatedAt: "تم التحديث في",
    fromTime: "من وقت",
    toTime: "إلى وقت",
    backToOrders: "العودة إلى الطلبات",
    tablesList: "قائمة الطاولات",
    backToTablesList: "العودة إلى قائمة الطاولات",
    showDetails: "عرض التفاصيل",
    receiptDetailsPage: "صفحة تفاصيل الإيصال",
    checkoutQrCodeAlt: "رمز QR للدفع",
    vat: "ضريبة القيمة المضافة",
    net: "الصافي",
    tax: "الضريبة",
    gross: "الإجمالي",
    sendingEmailFailed: "فشل إرسال البريد الإلكتروني!",
    paymentFailed: "فشل الدفع",
    openPayments: "المدفوعات المفتوحة",
    Open_Payments: "المدفوعات المفتوحة",
    openPaymentsReport: "تقرير المدفوعات المفتوحة",
    report: "تقرير",
    openPaymentStatistics: "إحصاءات الدفع المفتوح",
    allOrderItemsHaveBeenPaid: "تم دفع جميع عناصر هذا الطلب",
    noItemsHaveBeenAddedInThisOrder: "لم تتم إضافة أي عناصر إلى هذا الطلب",
    thisItemPaymentIsAwaitingConfirmation: "دفع هذا العنصر بانتظار التأكيد",
    yourOrderPaymentIsAwaitingConfirmation: "هناك دفعة لهذا الطلب بانتظار التأكيد",
    editableInTime: "قابل للتعديل خلال {{minutes}}د {{seconds}}ث",
    thisItemHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "تم دفع هذا العنصر عبر POS وهو بانتظار تأكيد الدفع",
    yourOrderHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "تم دفع طلبك عبر POS وهو بانتظار تأكيد الدفع",
    generalSettings: "الإعدادات العامة",
    customItems: "عناصر مخصصة",
    printMethod: "طريقة الطباعة",
    singlePrintMethodDescription: "يمكن تفعيل طريقة طباعة واحدة فقط في كل مرة",
    printMethodBrowser: "نافذة طباعة المتصفح",
    printMethodBluetooth: "طابعة بلوتوث",
    printMethodUsb: "طابعة USB (تجريبية)",
    printMethodExternal: "طابعة / تطبيق خارجي",
    bluetoothUnavailable: "البلوتوث غير متاح في هذا المتصفح أو الجهاز",
    bluetoothSecureContextRequired: "تتطلب الطباعة عبر البلوتوث HTTPS أو localhost",
    bluetoothPrinterNotSupported: "طابعة البلوتوث المحددة غير مدعومة",
    noBluetoothPrinterSelected: "لم يتم اختيار طابعة بلوتوث",
    noCompatibleBluetoothPrinterFound: "لم يتم العثور على طابعة بلوتوث متوافقة أو اختيارها. غالبًا ما تكتشف المتصفحات فقط طابعات BLE/GATT، لذلك قد لا تظهر الطرز الكلاسيكية مثل Epson TM-m30 هنا",
    bluetoothAutoPrintRequiresSelection: "اختر طابعة بلوتوث يدويًا مرة واحدة قبل استخدام الطباعة التلقائية",
    bluetoothPrintingNotSupported: "الطباعة عبر البلوتوث غير مدعومة في هذا المتصفح أو الجهاز",
    usbUnavailable: "USB غير متاح في هذا المتصفح أو الجهاز",
    usbSecureContextRequired: "تتطلب الطباعة عبر USB HTTPS أو localhost",
    noCompatibleUsbPrinterFound: "لم يتم العثور على طابعة USB متوافقة أو اختيارها",
    usbAccessDenied: "رفض المتصفح أو نظام التشغيل الوصول إلى طابعة USB المحددة. أغلق تطبيقات الطابعة الأخرى وتحقق من أذونات USB في النظام ثم حاول مرة أخرى",
    usbAutoPrintRequiresSelection: "اختر طابعة USB يدويًا مرة واحدة قبل استخدام الطباعة التلقائية",
    usbPrintingNotSupported: "الطباعة عبر USB غير مدعومة للجهاز المحدد",
    printerSize: "حجم الطابعة",
    useExternalPrinter: "استخدام طابعة خارجية",
    bluetoothPrinterDetails: "يمكنك إرسال الطباعة إلى أجهزة الطباعة عبر البلوتوث أو تعطيل هذا الخيار لاختيار طابعة من الطابعات المتصلة بهذا الجهاز",
    usbPrinterDetails: "دعم تجريبي لطابعات USB المتوافقة مع ESC/POS على Chrome أو Edge لسطح المكتب. قد تحتاج إلى اختيار الطابعة يدويًا مرة واحدة قبل أن تستخدمها الطباعة التلقائية. في Windows قد تحتاج الطابعة أيضًا إلى وضع Vendor Class وبرنامج تشغيل متوافق مع WinUSB قبل ظهورها في قائمة المتصفح",
    externalPrinterDetails: "يمكنك إرسال الطباعة إلى طابعات خارجية متصلة بالتطبيق أو تعطيل هذا الخيار لاختيار طابعة من الطابعات المتصلة بهذا الجهاز",
    autoPrint: "طباعة تلقائية",
    autoPrintDescription: "الطباعة تلقائيًا بعد قبول الطلب أو بعد وصول حدث ويب سوكيت لطلب مدفوع",
    autoPrintUnavailableForBrowserDescription: "الطباعة التلقائية غير متاحة عند استخدام نافذة طباعة المتصفح",
    browserPrintMethodNotice: "نافذة طباعة المتصفح تتطلب دائمًا تأكيدًا، لذلك لا يمكن طباعة الإيصالات تلقائيًا",
    selectAllPayablesByDefault: "تحديد كل العناصر القابلة للدفع افتراضيًا",
    selectAllPayablesByDefaultOnThePaymentPage: "تحديد كل العناصر القابلة للدفع افتراضيًا في صفحة الدفع",
    virtualKeyboard: "لوحة مفاتيح افتراضية",
    virtualKeyboardDescription: "استخدم لوحة المفاتيح داخل التطبيق في الحقول المدعومة",
    virtualKeyboardInfoLabel: "مساعدة لوحة المفاتيح",
    virtualKeyboardDisableHint: "إذا كنت تفضّل لوحة مفاتيح جهازك، يمكنك إيقاف هذه اللوحة من <0>الإعدادات</0>.",
    delivery: "توصيل",
    deliveryAddress: "عنوان التوصيل",
    deliveryDetails: "تفاصيل التوصيل",
    addDeliveryDetails: "إضافة تفاصيل التوصيل",
    editDeliveryDetails: "تعديل تفاصيل التوصيل",
    createDelivery: "إنشاء توصيل",
    fullAddress: "العنوان الكامل",
    postalCode: "الرمز البريدي",
    houseNumber: "رقم المبنى",
    served: "تم التقديم",
    doorNumber: "رقم الباب",
    apartmentEntrance: "مدخل الشقة",
    floor: "الطابق",
    extraAddressDetails: "تفاصيل إضافية للعنوان",
    fullName: "الاسم الكامل",
    dialCode: "مفتاح الدولة",
    phoneNumber: "رقم الهاتف",
    contactInformationAtPickup: "معلومات تواصل المستلم",
    recommended: "موصى به",
    deliverySummary: "ملخص التوصيل",
    Error: "خطأ",
    unexpectedErrorOccurred: "حدث خطأ",
    distance: "المسافة",
    duration: "المدة",
    minutes: "دقائق",
    deliveryPrice: "سعر التوصيل",
    deliveryFee: "رسوم التوصيل",
    itemsPrice: "قيمة العناصر",
    totalReceipt: "إجمالي الإيصال",
    successfulDeliveryRegistration: "تم تسجيل التوصيل بنجاح",
    successfulSendDelivery: "تم إرسال التوصيل بنجاح",
    customer: "العميل",
    withDelivery: "مع التوصيل",
    deliveryItem: "عنصر التوصيل",
    pickupDetails: "تفاصيل الاستلام",
    pickupDate: "تاريخ الاستلام",
    pickupTime: "وقت الاستلام",
    pickupDatetime: "تاريخ/وقت الاستلام المطلوب",
    pickupTimeLabel: "وقت الاستلام ({{format}})",
    pickupTimeBaseLabel: "وقت الاستلام الأساسي",
    pickupTimeFinalLabel: "وقت الاستلام النهائي",
    dropOffTime: "وقت التسليم",
    requestedPickupDatetime: "تاريخ/وقت الاستلام المطلوب الحالي",
    timePickerHour: "ساعة",
    timePickerMinute: "دقيقة",
    toggleTimeList: "إظهار/إخفاء قائمة الأوقات",
    pickupTimeInitialShort: "أساسي",
    orderTiming: "توقيت الطلب",
    maximumSelectableFreeCountHint: "أقصى عدد يمكن اختياره مجانًا",
    minimumSelectableCountHint: "أقل عدد يمكن اختياره",
    maximumSelectableCountHint: "أقصى عدد يمكن اختياره",
    maximumSelectedItemsReached: "وصل عدد العناصر المحددة إلى الحد الأقصى",
    changePickupTime: "تغيير وقت الاستلام",
    pickupTimeAllowedRangeHint: "بالنسبة إلى {{date}}، يمكن اختيار وقت الاستلام من {{start}} إلى {{end}}.",
    pickupDatetimeNotSetHint: "لم يتم تحديد تاريخ/وقت الاستلام بعد. يمكنك اختيار أي وقت استلام.",
    pickupDatetimeLimitedDelayHint: "يمكن تأخير تاريخ/وقت الاستلام المطلوب هذا حتى <1>30 دقيقة</1> ما دام الطلب لا يزال بانتظار القبول.",
    pickupDatetimeLockedHint: "تم تحديد تاريخ/وقت الاستلام لهذا الطلب بالفعل.",
    pickupTimeEditableOnlyWhenSuspended: "يمكن تغيير وقت الاستلام فقط عندما تكون حالة الطلب معلّقة.",
    pleaseEnterPickupDate: "يرجى إدخال تاريخ الاستلام",
    pickupDateMustBeTodayOrTomorrow: "يجب أن يكون تاريخ الاستلام اليوم أو غدًا للطلبات التي أنشأها النادل.",
    normalOrderCreationUnavailableTitle: "الطلبات العادية غير متاحة حاليًا",
    normalOrderCreationClosedAllDay: "المطعم مغلق في هذا اليوم، لذلك لا يمكن إنشاء طلبات.",
    normalOrderCreationClosedAtThisTime: "المطعم مغلق حاليًا. يمكن إنشاء الطلبات خلال ساعات العمل: {{hours}}.",
    waiterOrderNoAvailableOpenSlot: "لا يوجد وقت {{orderType}} صالح ضمن ساعات عمل المطعم في التواريخ المسموح بها حاليًا.",
    pickupDateOutsideOpeningHours: "التاريخ المحدد خارج أيام العمل المسموح بها لطلبات {{orderType}}.",
    pickupTimeOutsideOpeningHours: "الوقت المحدد خارج ساعات العمل المسموح بها لطلبات {{orderType}}.",
    openingHoursSelectableRangeHint: "بالنسبة إلى {{date}}، يمكن اختيار وقت {{orderType}} من {{start}} إلى {{end}}.",
    openingHoursClosedDayHint: "{{date}} مغلق لطلبات {{orderType}}.",
    openingHoursClosedDayCalendarHint: "مغلق لهذا النوع من الطلبات",
    openingHoursDisabledDatesHint: "يمكن اختيار التواريخ التي تحتوي على وقت {{orderType}} واحد متاح على الأقل ضمن ساعات عمل المطعم فقط.",
    openingHoursUnavailableTimesHint: "الأوقات التي لا يمكن اختيارها خارج ساعات عمل المطعم لطلبات {{orderType}} في التاريخ المحدد.",
    deliveryAndPickupOrders: "طلبات التوصيل والاستلام",
    orderId: "معرّف الطلب",
    orderStatus: "حالة الطلب",
    waiter: "النادل",
    fromCustomerApp: "من تطبيق العميل",
    orderType: "نوع الطلب",
    payByLink: "الدفع عبر الرابط",
    sendDelivery: "إرسال التوصيل",
    updateDelivery: "تحديث التوصيل",
    requestCourier: "طلب مندوب",
    sendCourierRequest: "إرسال طلب المندوب",
    sentToCourier: "تم الإرسال إلى المندوب",
    callCourier: "الاتصال بالمندوب",
    somethingWentWrong: "حدث خطأ ما",
    noPickupTimeProvidedForThisOrder: "لم يتم تحديد وقت استلام لهذا الطلب",
    pickupTimeCalculationForThisOrderFailed: "فشل حساب وقت الاستلام لهذا الطلب",
    itemEditFailed: "فشل تعديل العنصر",
    thisItemCannotBeEdited: "لا يمكن تعديل هذا العنصر.",
    problemInReadingItemEssentialDataMessage: "حدثت مشكلة أثناء قراءة المعلومات الأساسية للعنصر",
};

export default ar;
